<template>
  <div id="system-approve">
    <header-top></header-top>
    <main class="audit-logs-main">
      <div class="handle">
        <div class="left fl">
          <el-select
            v-model="timeFilter"
            @change="storeTime"
            placeholder="全部时间"
            class="handle-select"
          >
            <el-option
              v-for="item in options"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            ></el-option>
          </el-select>
          <el-date-picker
            align="center"
            v-model="dateRange"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
            @change="changeDate"
          ></el-date-picker>
        </div>
        <div class="right fr" :class="{ 'active-right': showAdvancedOptions }">
          <el-button
            v-if="!showAdvancedOptions"
            plain
            class="advanced-search-btn"
            @click="toggleAdvancedSearch"
            >高级搜索<i class="el-icon-caret-bottom"></i
          ></el-button>
          <span
            v-else
            class="advanced-search-btn-active"
            @click="toggleAdvancedSearch"
            >高级搜索 <i class="el-icon-caret-bottom"></i
          ></span>
          <el-input
            placeholder="用户名称"
            v-model="query.userName"
            @keyup.enter.native="getsystemApproveList"
          >
            <i
              class="el-icon-search el-input__icon input__suffix"
              slot="suffix"
              @click="getsystemApproveList"
            ></i>
          </el-input>

          <el-popover
            class="btn-group-right-btn"
            placement="top"
            title
            width="25"
            height="49"
            trigger="hover"
            content="刷新"
          >
            <div slot="reference">
              <div @click="getsystemApproveList">
                <svg-icon class="svg" icon-class="refresh-ico" />
              </div>
            </div>
          </el-popover>
          <!-- <el-popover
            placement="top"
            title
            width="25"
            height="49"
            trigger="hover"
            content="设置"
          >
            <div slot="reference">
              <div @click="showFiltrate = true">
                <svg-icon class="svg" icon-class="filtrate-ico" />
              </div>
            </div>
          </el-popover> -->
          <!-- <el-popover
            class="btn-group-right-btn"
            placement="top"
            title
            width="25"
            height="49"
            trigger="hover"
            content="下载"
          >
            <div slot="reference">
              <div @click="derive">
                <svg-icon class="svg" icon-class="derive-ico" />
              </div>
            </div>
          </el-popover> -->
        </div>
      </div>
      <!-- <div class="search-view" v-if="postSearch.length > 0">
        当前已选条件：
        <ul>
          <li v-for="(item, index) in postSearch" :key="index" v-show="postSearch.length < 6">
            <span class="post-search">{{item.key}}:{{ item.val }}</span>
          </li>
          <li v-show="postSearch.length > 6">...</li>
        </ul>
        <div class="clean" @click="cleanSearch">
          <svg-icon class="svg" icon-class="clean-ico"></svg-icon>清空条件
        </div>
      </div> -->
      <div class="table-info">
        <el-table :data="systemApprove" @sort-change="changeSort">
          <!-- <el-table-column
            type="index"
            width="50"
            align="center"
          ></el-table-column> -->
          <el-table-column
            label-class-name="tab-tit"
            label="操作人"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              <div class="name-worknum">
                <div>
                  <span>{{ scope.row.userName | nullValue }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label-class-name="tab-tit"
            label="操作时间"
            width="150"
            align="center"
            sortable="custom"
            prop="creationTime"
          >
            <template slot-scope="scope">
              <div>
                <span>{{ scope.row.creationTime }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label-class-name="tab-tit"
            label="操作内容"
            min-width="200"
            align="center"
          >
            <template slot-scope="scope">
              <div class="name-worknum">
                <div>
                  <span
                    >{{ scope.row.userName | nullValue }}于{{
                      scope.row.creationTime
                    }}{{
                      scope.row.action == "LoginSucceeded"
                        ? "登录成功"
                        : "登录失败"
                    }}</span
                  >
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            label-class-name="tab-tit"
            label="登录信息"
            min-width="150"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div>
                <span>{{ scope.row.browserInfo | nullValue }}</span>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column
            label-class-name="tab-tit"
            label="Ip地址"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              <div class="name-worknum">
                <div>
                  <span>{{ scope.row.clientIpAddress | nullValue }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <div class="table-operation">
                <el-button
                  @click.native.prevent="quickView(scope.row)"
                  type="text"
                  
                  >详情</el-button
                >
              </div>
            </template>
          </el-table-column> -->
          <template slot="empty">
            <div class="loading-box" v-if="isLoading">
              <img
                src="@/assets/image/loading.png"
                alt="loading"
                class="loading-ico"
              />
              数据加载中...
            </div>
            <div class="empty-box" v-if="!isLoading && !systemApprove.length">
              列表为空
            </div>
          </template>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageIndex"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="query.maxResultCount"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        ></el-pagination>
      </div>
    </main>
    <div
      v-if="showAdvancedOptions"
      class="advanced-options-shadow"
      @click="toggleAdvancedSearch"
    >
      <div class="advanced-options-box" @click.stop="stopPropagation">
        <div class="advanced-options-list">
          <el-form label-width="4rem" label-position="left">
            <el-row>
              <el-col :span="10">
                <el-form-item label="相关id">
                  <el-input
                    placeholder="请输入相关id"
                    v-model="query.correlationId"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10" :offset="2">
                <el-form-item label="身份信息">
                  <el-input
                    placeholder="请输入身份信息"
                    v-model="query.identity"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item label="应用名称">
                  <el-input
                    placeholder="请输入应用名称"
                    v-model="query.applicationName"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10" :offset="2">
                <el-form-item label="操作状态">
                  <el-input
                    placeholder="请输入操作状态"
                    v-model="query.actionName"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="advanced-options-btn">
          <el-button plain class="search-btn" @click="reset">取消</el-button>
          <el-button
            type="primary"
            class="search-btn"
            @click="getsystemApproveList"
            >搜索</el-button
          >
        </div>
      </div>
    </div>
    <el-drawer
      title="详情"
      :with-header="false"
      :visible.sync="isDrawerShow"
      direction="rtl"
    >
      <div class="drawer-title">
        <div class="basic-item-title basic-title-edit">详细信息</div>
        <span @click="isDrawerShow = false">
          <svg-icon icon-class="close-ico" />
        </span>
      </div>
      <el-form label-position="left" label-width="6rem">
        <div class="basic-item">
          <!-- <div class="basic-item-title basic-title-edit">基本信息</div> -->
          <div class="basic-item-main">
            <div class="main-item">
              <el-tooltip
                class="item"
                effect="dark"
                :content="auditLogInfo.url"
                placement="top-start"
              >
                <el-form-item label="Url">
                  {{ auditLogInfo.url | valLength(15) }}</el-form-item
                >
              </el-tooltip>
              <el-form-item label="客户端IP地址">{{
                auditLogInfo.clientIpAddress | nullValue
              }}</el-form-item>
              <el-form-item label="客户端名称">
                {{ auditLogInfo.clientName | nullValue }}
              </el-form-item>
              <el-form-item label="额外属性">{{
                auditLogInfo.extraProperties | nullValue
              }}</el-form-item>
            </div>
            <div class="main-item basic-item-right">
              <el-form-item label="用户名">{{
                auditLogInfo.residence | nullValue
              }}</el-form-item>
              <el-form-item label="时间">{{
                auditLogInfo.executionTime | nullValue
              }}</el-form-item>
              <el-form-item label="持续时间">{{
                auditLogInfo.executionDuration | nullValue
              }}</el-form-item>
              <el-tooltip
                class="item"
                effect="dark"
                :content="auditLogInfo.browserInfo"
                placement="top-start"
              >
                <el-form-item label="浏览器信息">
                  {{ auditLogInfo.browserInfo | valLength(15) }}
                </el-form-item>
              </el-tooltip>
              <el-form-item label="应用名称">{{
                auditLogInfo.applicationName | nullValue
              }}</el-form-item>
              <el-form-item label="关联Id">{{
                auditLogInfo.correlationId | nullValue
              }}</el-form-item>
            </div>
          </div>
          <div
            class="basic-item"
            v-if="auditLogInfo.actions && auditLogInfo.actions.length > 0"
          >
            <div class="basic-item-title">操作</div>
            <el-table
              :data="auditLogInfo.actions"
              style="width: 100%"
              header-align="center"
            >
              <el-table-column
                prop="organizationUnit"
                label="服务名称"
                min-width="200"
              >
                <template slot-scope="scope">{{
                  scope.row.serviceName | nullValue
                }}</template>
              </el-table-column>
              <el-table-column
                prop="organizationUnit"
                label="调用方法名称"
                min-width="150"
              >
                <template slot-scope="scope">{{
                  scope.row.methodName | nullValue
                }}</template>
              </el-table-column>
              <el-table-column
                prop="organizationUnit"
                label="操作时间"
                min-width="150"
              >
                <template slot-scope="scope">{{
                  scope.row.executionTime | nullValue
                }}</template>
              </el-table-column>
              <el-table-column
                prop="more"
                label="持续时间"
                align="center"
                min-width="100"
              >
                <template slot-scope="scope">{{
                  scope.row.executionDuration | nullValue
                }}</template>
              </el-table-column>
            </el-table>
          </div>

          <div class="exceptions">
            <el-form-item label="异常信息" class="auto-height">{{
              auditLogInfo.exceptions | nullValue
            }}</el-form-item>
            <el-form-item label="备注" class="auto-height">{{
              auditLogInfo.comments | nullValue
            }}</el-form-item>
          </div>
        </div>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import headerTop from "@/components/HeaderTop";
import { getSecurityLogs } from "@/http/api/role";
import { dateFormat } from "@/common/filters";
export default {
  components: {
    headerTop,
  },
  data() {
    return {
      dateRange: [],
      query: {
        skipCount: 0,
        maxResultCount: 20,
        startTime: null,
        endTime: null,
        sorting: "",
        userName: "",
        applicationName: "",
        correlationId: "",
        clientId: "",
        identity: "",
        actionName: "",
      },
      postSearch: [],
      totalCount: 0,
      pageIndex: 1,
      isLoading: true,
      systemApprove: [],
      isDrawerShow: false,
      showAdvancedOptions: false,
      auditLogInfo: {},
      timeFilter: "",
      options: [
        {
          key: "tody",
          value: "今天",
        },
        {
          key: "yestady",
          value: "昨天",
        },
        {
          key: "week",
          value: "近七天",
        },
      ],
    };
  },

  mounted() {
    this.getsystemApproveList();
  },
  methods: {
    storeTime() {
      if (this.timeFilter == "tody") {
        let startTime = new Date(
          new Date(new Date().toLocaleDateString()).getTime()
        );
        let endTime = new Date();
        this.dateRange = [startTime, endTime];
        this.getsystemApproveList();
      } else if (this.timeFilter == "yestady") {
        let startTime = new Date(
          new Date().setHours(0, 0, 0, 0) - 24 * 60 * 60 * 1000 - 1000
        );
        let endTime = new Date(new Date().setHours(0, 0, 0, 0) - 1);
        this.dateRange = [startTime, endTime];
        this.getsystemApproveList();
      } else {
        let startTime = new Date(
          new Date().getTime() - 24 * 60 * 60 * 1000 * 7
        );
        let endTime = new Date();
        this.dateRange = [startTime, endTime];
        this.getsystemApproveList();
      }

      
    },
    changeDate(val) {

      this.getsystemApproveList();
    },
    cleanSearch() {
      this.postSearch = [];
      this.reset();
    },
    stopPropagation() {},
    toggleAdvancedSearch() {
      this.showAdvancedOptions = !this.showAdvancedOptions;
    },
    reset() {
      this.query.userName = "";
      this.query.applicationName = "";
      this.query.correlationId = "";
      this.query.identity = "";
      this.query.actionName = "";
      this.query.clientId = "";

      this.getsystemApproveList();
    },
    derive() {},
    quickView(row) {
      this.isDrawerShow = true;
      this.getAuditLogInfo(row.id);
    },
    changeSort(val) {
      if (val.order == "descending") {
        this.query.sorting = `${val.prop} desc`;
      } else {
        this.query.sorting = `${val.prop} asc`;
      }
      this.getsystemApproveList();
    },
    getAuditLogInfo(id) {
      getAuditLogDetails(id).then((res) => {
        this.auditLogInfo = res.result;
      });
    },
    handleSizeChange(val) {
      this.pageIndex = 1;
      this.query.maxResultCount = val;
      this.getsystemApproveList();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getsystemApproveList();
    },
    toDetails(val) {
      if (val.title != "员工入离调转汇总") {
        this.$router.push({ path: `personnel-details?name=${val.title}` });
      } else {
        this.$router.push({ path: `/hr/statistical-summary` });
      }
    },
    getsystemApproveList() {
      //console.log("获取的时间筛选", this.dateRange[0],this.dateRange[1]);
      if (this.dateRange != "" && this.dateRange != null) {
        this.query.startTime = this.dateRange[0];
        this.query.endTime = this.dateRange[1];
      } else {
        this.query.startTime = "";
        this.query.endTime = "";
      }
      if (this.query.startTime) {
        this.query.startTime = dateFormat(this.query.startTime);
      }
      if (this.query.endTime) {
        this.query.endTime = dateFormat(this.query.endTime);
      }
      this.isLoading = true;
      this.query.skipCount = (this.pageIndex - 1) * this.query.maxResultCount;

      getSecurityLogs(this.query).then((res) => {
        //console.log(res);
        this.showAdvancedOptions = false;
        this.isLoading = false;
        this.systemApprove = res.result.items;
        this.totalCount = res.result.totalCount;
      });
    },
  },
};
</script>
<style scoped lang='scss'>
@import "@/styles/mixin.scss";
#system-approve {
  .handle {
    width: 100%;
    height: 40px;
    min-width: 760px;
    .left,
    .right {
      display: flex;
      align-items: center;
      .el-date-editor {
        border-radius: 0 4px 4px 0;
      }
    }
    .left {
      ::v-deep.el-select {
        width: 100px;
        .el-input__inner{
          border-radius: 4px 0 0 4px;
        }
      }
    }
    .right {
      margin-right: 7px;
      .el-input {
        margin-right: 5px;
        width: 120px;
      }
      .btn-group-right-btn {
        padding: 0 5px;
      }
      .advanced-search-btn {
        margin-right: 10px;
        height: 30px;
        i {
          margin-left: 3px;
        }
      }
      .advanced-search-btn-active {
        font-size: 14px;
        background: #fff;
        position: relative;
        top: 4px;
        z-index: 110;
        display: inline-block;
        padding: 4px 20px 12px;
        border: 1px solid #d3d7db;
        border-bottom: 0;
        border-radius: 4px 4px 0 0;
        // margin-left: 10px;
        margin-right: 10px;
      }
    }
    .active-right {
      margin-top: -5px;
    }

    .svg {
      width: 12px;
      height: 16px;
      cursor: pointer;
    }
  }
  .search-view {
    border-top: solid 1px #dddddd;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 20px;
    ul {
      padding: 0;
      display: flex;
      align-items: center;
    }
    li {
      margin-right: 10px;
      padding: 5px 10px;
      background: #fff;
      // font-size: 12px;
      color: #000000;
      border: 1px solid rgba(204, 204, 204, 1);
      div {
        position: relative;
        left: 2px;
        top: -2px;
        display: inline-block;
        width: 8px;
        height: 8px;
      }
      .position-search,
      .post-search {
        margin-right: 5px;
      }
      .svg {
        width: 8px;
        height: 8px;
        cursor: pointer;
      }
    }
    .clean {
      cursor: pointer;
      margin-left: 10px;
    }
  }
  .audit-logs-main {
    padding: 20px;

    .table-info {
      box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2);
    }
    .el-table {
      // min-height: calc( 100vh - 210px);

      // font-size: 12px;
      background: #fff;
      .http-info {
        @include flex(row, center);
        .code,
        .method {
          // font-size: 12px;
          font-weight: 700;
          width: 50px;
          padding: 0;
          text-align: center;
          text-shadow: 0 1px 0 rgba(0, 0, 0, 0.1);
          font-family: sans-serif;
          color: #fff;
        }
        .error {
          background: #f93e3e;
        }
        .success {
          background: #009688;
        }
        .method {
          margin-left: 5px;
        }
        .post {
          background: #009688;
        }
        .put {
          background: #fca130;
        }
        .delete {
          background: #f93e3e;
        }
        .get {
          background: #61affe;
        }
      }
      .table-operation {
        display: flex;
        .el-button + .el-button {
          margin-left: 10px;
        }
      }
    }
    .pagination {
      padding: 15px 10px;
    }
  }
  .advanced-options-shadow {
    width: calc(100% - 65px);
    height: calc(100vh - 80px);

    position: absolute;
    top: 97px;
    right: 43px;
    z-index: 100;
    background: rgba(0, 0, 0, 0.2);
    .advanced-options-box {
      padding: 0 20px;
      min-height: 200px;
      background: #fff;
      border-top: 1px solid #d3d7db;
      border-bottom: 1px solid #d3d7db;
      .advanced-options-title {
        padding: 15px 0;
        border-bottom: 1px solid #d3d7db;
        color: #333333;
        font-size: 14px;
      }
      .advanced-options-list {
        margin-top: 20px;
        border-bottom: 1px solid #d3d7db;
        .advanced-select {
          width: 100%;
        }
      }
      .advanced-options-btn {
        text-align: center;
        padding: 20px 0;
      }
    }
  }
  ::v-deep .el-drawer {
    width: 700px !important;
    .basic-item {
      margin-bottom: 5px;

      .basic-item-title {
        margin-top: 20px;
        margin-bottom: 20px;
        font-size: 14px;
        font-weight: bold;
        color: rgba(0, 0, 0, 1);
      }

      .basic-title-edit {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .basic-edit {
          font-size: 14px;
          font-weight: 400;
          color: $--color-primary;
          cursor: pointer;
        }
      }

      .basic-item-main {
        display: flex;

        .main-item {
          width: 50%;

          .el-select,
          .el-input {
            width: 330px;
          }

          .work-card {
            .work-card-item {
              margin-bottom: 15px;
              line-height: 0;

              .work-card-img {
                width: 143px;
                height: 148px;
              }
            }

            .work-card-print {
              margin-bottom: 0;
            }
          }

          .encrypt-number {
            display: flex;

            span {
              display: inline-block;
              width: 115px;
            }

            .show-svg {
              margin-left: 8px;

              .svg-icon {
                margin-top: -2px;
                cursor: pointer;
              }
            }
          }

          .phone-number {
            span {
              width: 75px;
            }
          }

          .job-num-box {
            display: flex;
            // font-size: 12px;
            font-weight: 400;
            color: #000;
            vertical-align: middle;

            p {
              margin: 0;
            }

            .job-num-btn {
              margin-left: 10px;
              // font-size: 12px;
              font-weight: 400;
              color: $--color-primary;
            }
          }

          .account-lock {
            display: inline-block;
            margin-right: 5px;
          }
        }

        .basic-item-right {
          padding-left: 50px;
        }

        .el-form-item {
          height: 30px;
          margin-bottom: 14px;
        }
      }

      .el-table {
        margin-bottom: 25px;
        .table-empty {
          color: $--color-primary;
          cursor: pointer;
        }
        .grade-box {
          @include flex(row, baseline);
          .grade-main {
            margin-left: 9px;
            border: 1px solid $--color-primary;
            padding: 0 5px;

            // font-size: 12px;
            font-weight: 400;
            line-height: 18px;
            color: $--color-primary;
          }
        }
      }
    }
    .exceptions {
      .auto-height {
        .el-form-item__content {
          word-wrap: break-word;
          word-break: break-all;
          width: 85%;
        }
      }
    }
    .margin-bottom {
      margin-bottom: 0;
    }
    .lockout-box {
      display: flex;
      align-items: center;

      .svg-icon {
        margin-right: 5px;
      }
    }

    .is-lockout {
      color: #f44242;
    }

    .not-lockout {
      color: #0abf5b;
    }
  }
}
</style>